import { Controller } from "stimulus"

// #1996: de lijst in Schema toevoegen: zoeken, filters met aantallen, sorteren,
// vijf per pagina. De gekozen regel laadt de details in de rechterkolom.
const PER_PAGINA = 5

const normaliseer = (tekst) => tekst.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase()

export default class extends Controller {
  static targets = ["regel", "lijst", "zoek", "optie", "gevonden", "bereik", "paginas", "sortering", "frame"]
  static values = { soort: String, url: String, frame: String, gevonden: String, gevondenEen: String, bereik: String }

  connect() {
    this.pagina = 1
    this.gekozen = null
    this.zichtbaar = () => this.kiesEerste()
    this.element.addEventListener("schema-lijst:zichtbaar", this.zichtbaar)
    this.toon()
  }

  disconnect() {
    this.element.removeEventListener("schema-lijst:zichtbaar", this.zichtbaar)
  }

  filter() {
    this.pagina = 1
    this.toon()
  }

  wis() {
    this.zoekTarget.value = ""
    this.optieTargets.forEach((optie) => { optie.checked = false })
    this.filter()
  }

  kies(event) {
    this.selecteer(event.currentTarget.closest("li"))
  }

  naarPagina(event) {
    this.pagina = Number(event.currentTarget.dataset.pagina)
    this.toon()
  }

  toon() {
    const gevonden = this.gesorteerd(this.regelTargets.filter((regel) => this.past(regel)))
    const paginas = Math.max(Math.ceil(gevonden.length / PER_PAGINA), 1)
    this.pagina = Math.min(this.pagina, paginas)
    const van = (this.pagina - 1) * PER_PAGINA
    const pagina = gevonden.slice(van, van + PER_PAGINA)

    gevonden.forEach((regel) => this.lijstTarget.appendChild(regel))
    this.regelTargets.forEach((regel) => { regel.hidden = !pagina.includes(regel) })

    this.zetTellers()
    this.gevondenTarget.textContent = gevonden.length === 1
      ? this.gevondenEenValue
      : this.gevondenValue.replace("%{aantal}", gevonden.length)
    this.bereikTarget.textContent = gevonden.length === 0 ? "" : this.bereikValue
      .replace("%{van}", van + 1).replace("%{tot}", van + pagina.length).replace("%{totaal}", gevonden.length)
    this.zetPaginas(paginas)
    this.kiesEerste()
  }

  kiesEerste() {
    if (this.element.hidden) return
    if (this.gekozen && this.regelTargets.some((regel) => regel === this.gekozen && this.past(regel))) return

    const eerste = this.regelTargets.find((regel) => !regel.hidden)
    if (eerste) this.selecteer(eerste)
  }

  selecteer(regel) {
    this.gekozen = regel
    this.regelTargets.forEach((kandidaat) => {
      const knop = kandidaat.querySelector("button")
      knop.classList.toggle("is-gekozen", kandidaat === regel)
      knop.setAttribute("aria-pressed", kandidaat === regel ? "true" : "false")
    })

    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("soort", this.soortValue)
    url.searchParams.set("id", regel.dataset.id)
    this.frameTarget.setAttribute("src", url.pathname + url.search)
  }

  // Past de regel bij zoekterm en filters; `behalve` laat één filtergroep weg,
  // zodat de teller van die groep toont wat een extra vinkje zou opleveren
  past(regel, behalve = null) {
    const termen = normaliseer(this.zoekTarget.value).split(/\s+/).filter(Boolean)
    if (!termen.every((term) => regel.dataset.zoek.includes(term))) return false

    return Object.entries(this.gekozenFilters()).every(([groep, waarden]) => {
      if (groep === behalve) return true

      const eigen = (regel.dataset[groep] || "").split("|")
      return waarden.some((waarde) => eigen.includes(waarde))
    })
  }

  gekozenFilters() {
    return this.optieTargets.filter((optie) => optie.checked).reduce((filters, optie) => {
      (filters[optie.dataset.groep] ||= []).push(optie.value)
      return filters
    }, {})
  }

  gesorteerd(regels) {
    if (this.sorteringTarget.value === "naam") {
      return [...regels].sort((a, b) => a.dataset.naam.localeCompare(b.dataset.naam, "nl"))
    }
    return [...regels].sort((a, b) => Number(b.dataset.nieuw) - Number(a.dataset.nieuw))
  }

  zetTellers() {
    this.optieTargets.forEach((optie) => {
      const aantal = this.regelTargets.filter((regel) => this.past(regel, optie.dataset.groep) &&
        (regel.dataset[optie.dataset.groep] || "").split("|").includes(optie.value)).length
      optie.closest("label").querySelector("[data-teller]").textContent = `(${aantal})`
    })
  }

  zetPaginas(paginas) {
    const knoppen = []
    if (paginas > 1) {
      knoppen.push(this.paginaKnop(Math.max(this.pagina - 1, 1), "‹", this.pagina === 1))
      for (let nummer = 1; nummer <= paginas; nummer += 1) knoppen.push(this.paginaKnop(nummer, String(nummer), false))
      knoppen.push(this.paginaKnop(Math.min(this.pagina + 1, paginas), "›", this.pagina === paginas))
    }
    this.paginasTarget.replaceChildren(...knoppen)
  }

  paginaKnop(nummer, tekst, uit) {
    const knop = document.createElement("button")
    knop.type = "button"
    knop.textContent = tekst
    knop.disabled = uit
    knop.dataset.pagina = nummer
    knop.dataset.action = "schema-lijst#naarPagina"
    knop.className = `mt-pagina${tekst === String(this.pagina) ? " is-actief" : ""}`
    return knop
  }
}
